var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.steps.length > 0
    ? _c(
        "section",
        { staticClass: "progressTracker" },
        _vm._l(_vm.steps, function (step, index) {
          return _c(
            "span",
            {
              key: step.name,
              class: {
                active: step.active,
                completed: step.completion > 99,
                step: true,
              },
            },
            [
              _c("span", { staticClass: "checkContainer" }, [
                _c("i", {
                  staticClass: "fa fa-check",
                  class: { completed: step.completion > 99 },
                }),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "bar base" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "bar completion",
                style: { width: step.completion + "%" },
              }),
              _vm._v(" "),
              step.link
                ? _c(
                    "a",
                    { staticClass: "stepName", attrs: { href: step.link } },
                    [_c("span", [_vm._v(_vm._s(step.display))])]
                  )
                : _vm._e(),
              _vm._v(" "),
              !step.link
                ? _c(
                    "span",
                    {
                      staticClass: "stepName",
                      on: {
                        click: function ($event) {
                          return _vm.handleStepClick(step, index)
                        },
                      },
                    },
                    [_vm._v(_vm._s(step.display))]
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }